function getDurationStringHelper(durationType, durationFixed, durationIntervalMin, durationIntervalMax, monthsShort, yearsShort) {
    if(durationType == 'fixed') {
        return formatDuration(durationFixed, monthsShort, yearsShort);
    }

    if(durationIntervalMin >= 12) {
        // only years
        return `${toYears(durationIntervalMin)} - ${toYears(durationIntervalMax)} ${yearsShort}`;
    }

    if(durationIntervalMax < 12) {
        // only months
        return `${durationIntervalMin} - ${durationIntervalMax} ${monthsShort}`;
    }

    return `${durationIntervalMin} ${monthsShort} - ${toYears(durationIntervalMax)} ${yearsShort}`;
}

function minOrMaxDurationStringHelper(durationType, durationFixed, minOrMaxDuration, monthsShort, yearsShort) {
    if (durationType == 'fixed') {
        return formatDuration(durationFixed, monthsShort, yearsShort);
    }

    return formatDuration(minOrMaxDuration, monthsShort, yearsShort);
}

function formatDuration(duration, monthsShort, yearsShort) {
    if(duration >= 12) {
        return `${toYears(duration)} ${yearsShort}`;
    }   

    return `${duration} ${monthsShort}`;
}

function toYears(months) {
    return Math.round(months / 12);
}

export default (superClass) => {
    return class extends superClass {
        
        get durationType() {
            return this._data.duration_type;
        }

        get minDuration() {
            if (this.durationType == 'fixed') {
                return this._data.duration_fixed;
            }

            return this._data.duration_interval_min;
        }

        getMinDurationString(monthsShort = 'mån', yearsShort = 'år') {
            return this.minOrMaxDurationString('duration_interval_min', monthsShort, yearsShort)
        }

        get maxDuration() {
            if (this.durationType == 'fixed') {
                return this._data.duration_fixed;
            }

            return this._data.duration_interval_max;
        }

        getMaxDurationString(monthsShort = 'mån', yearsShort = 'år') {
            return this.minOrMaxDurationString('duration_interval_max', monthsShort, yearsShort)
        }

        getDurationString(monthsShort = 'mån', yearsShort = 'år') {
            return getDurationStringHelper(
                this.durationType, 
                this._data.duration_fixed, 
                this._data.duration_interval_min, 
                this._data.duration_interval_max, 
                monthsShort, 
                yearsShort
            );
        }

        minOrMaxDurationString(dataKey, monthsShort, yearsShort) {
            return minOrMaxDurationStringHelper(
                this.durationType, 
                this._data.duration_fixed, 
                this._data[dataKey], 
                monthsShort, 
                yearsShort
            )
        }
        
        get hasDebtCollectionDuration() {

            const validateValue = (debtCollectionValue, value) => {
                return Boolean(debtCollectionValue) && debtCollectionValue > 0 && debtCollectionValue !== value
            }

            if (this.durationType === 'fixed') {
                return validateValue(this._data.duration_fixed_debt_collection, this._data.duration_fixed);
            }
            
            return validateValue(this._data.duration_interval_max_debt_collection, this._data.duration_interval_max) || 
                validateValue(this._data.duration_interval_min_debt_collection, this._data.duration_interval_min)
        }
        
        get minDurationDebtCollection() {
            if (this.durationType == 'fixed') {
                return this._data.duration_fixed_debt_collection || this._data.duration_fixed;
            }
            return this._data.duration_interval_min_debt_collection || this._data.duration_interval_min;
        }

        getMinDurationDebtCollectionString(monthsShort = 'mån', yearsShort = 'år') {
            return this.minOrMaxDurationDebtCollectionString('duration_interval_min_debt_collection', 'duration_interval_min', monthsShort, yearsShort);
        }

        get maxDurationDebtCollection() {
            if (this.durationType == 'fixed') {
                return this._data.duration_fixed_debt_collection || this._data.duration_fixed;
            }
            return this._data.duration_interval_max_debt_collection || this._data.duration_interval_max;
        }

        getMaxDurationDebtCollectionString(monthsShort = 'mån', yearsShort = 'år') {
            return this.minOrMaxDurationDebtCollectionString('duration_interval_max_debt_collection', 'duration_interval_max', monthsShort, yearsShort);
        }

        minOrMaxDurationDebtCollectionString(dataKey, fallbackDataKey, monthsShort, yearsShort) {
            return minOrMaxDurationStringHelper(
                this.durationType, 
                this._data.duration_fixed_debt_collection || this._data.duration_fixed, 
                this._data[dataKey] || this._data[fallbackDataKey], 
                monthsShort, 
                yearsShort
            )
        }

        getDurationDebtCollectionString(monthsShort = 'mån', yearsShort = 'år') {
            return getDurationStringHelper(
                this.durationType, 
                this._data.duration_fixed_debt_collection || this._data.duration_fixed, 
                this._data.duration_interval_min_debt_collection || this._data.duration_interval_min, 
                this._data.duration_interval_max_debt_collection || this._data.duration_interval_max, 
                monthsShort, 
                yearsShort
            );
        }

        get absoluteMinDuration() {
            const minDurations = [this.minDuration, this.minDurationDebtCollection].filter(Boolean);
            return minDurations.length ? Math.min(...minDurations) : 0;
        }

        getAbsoluteMinDurationString(monthsShort = 'mån', yearsShort = 'år') {
            return formatDuration(this.absoluteMinDuration, monthsShort, yearsShort);
        }

        get absoluteMaxDuration() {
            const maxDurations = [this.maxDuration, this.maxDurationDebtCollection];
            return Math.max(...maxDurations);
        }

        getAbsoluteMaxDurationString(monthsShort = 'mån', yearsShort = 'år') {
            return formatDuration(this.absoluteMaxDuration, monthsShort, yearsShort);
        }

        getAbsoluteDurationString(monthsShort = 'mån', yearsShort = 'år') {
            const durationType = this.absoluteMinDuration === this.absoluteMaxDuration ? 'fixed' : 'interval';

            return getDurationStringHelper(
                durationType, 
                this.absoluteMinDuration, 
                this.absoluteMinDuration, 
                this.absoluteMaxDuration, 
                monthsShort, 
                yearsShort
            );
        }

        toYears(months) {
            return toYears(months);
        }
    }
}